import { documentHasElements } from "modules/dom";
import "./tab-container-block.scss";

documentHasElements(".js-tab-container-block", (tabContainerBlocks) => {
    tabContainerBlocks.forEach((tabContainerBlock) => {
        const blocks = tabContainerBlock.querySelectorAll(".tab-blocks > div");
        const tabs = tabContainerBlock.querySelector(".tab-list");

        // Create list items for each block
        blocks.forEach((block, index) => {
            block.setAttribute("data-item", index.toString());

            const listItem = document.createElement("li");
            const blockId = block.getAttribute("id");

            listItem.setAttribute("data-item", index.toString());
            
            if (blockId !== null) {
                listItem.innerHTML = blockId.toString();
            }

            if (listItem && tabs) {
                tabs.appendChild(listItem);
            }
        });

        const tabButtons = tabContainerBlock.querySelectorAll(".tab-list li");

        // Initialize first tab as active
        tabButtons[0].classList.add('active');
        blocks[0].classList.add('active');

        // Handle tab click events
        tabButtons.forEach((tab) => {
            tab.addEventListener("click", () => {
                const isActive = tab.classList.contains("active");
                const tabId = tab.getAttribute("data-item");
                const tabContent = document.querySelectorAll(`div[data-item="${tabId}"]`);

                if (isActive) {
                    return
                }

                // Close all tabs
                tabButtons.forEach((otherTab) => otherTab.classList.remove("active"));
                blocks.forEach((block) => block.classList.remove('active'));

                // Open clicked tab if not already active
                if (!isActive) {
                    tab.classList.add("active");
                    tabContent[0].classList.add('active');
                }
            });
        });
    });
});